import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth-guard'; 
import { moduleAccessGuard } from './core/guards/module-access.guard';

export const routes: Routes = [
  { path: '', loadComponent: () => import('./features/login-page/login-page').then(c => c.LoginPage) },
  {
    path: 'login',
    loadComponent: () => import('./features/login-page/login-page').then(c => c.LoginPage)
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./features/dashboard-page/dashboard-page').then(c => c.DashboardPage),
    canActivate: [authGuard]
  },
  {
    path: 'home',
    loadComponent: () => import('./features/home-page/home-page').then(c => c.HomePage),
    canActivate: [authGuard]
  },
  {
    path: 'logout',
    loadComponent: () => import('./features/logout-page/logout-page').then(c => c.LogoutPage),
    canActivate: [authGuard]
  },
  
  {
    path: 'sap-business-one',
    loadComponent: () => import('./features/sap-business-one/sap-business-one-page/sap-business-one-page').then(c => c.SapBusinessOnePage),
    canActivate: [authGuard]
  },
  // SAP Business One - Ventas
  {
    path: 'sales-order',
    loadComponent: () => import('./features/sap-business-one/sales-order-page/sales-order-page').then(c => c.SalesOrderPage),
    canActivate: [authGuard, moduleAccessGuard('oOrders')]
  },
  {
    path: 'sales-order-detail/:docNum',
    loadComponent: () => import('./features/sap-business-one/sales-order-detail-page/sales-order-detail-page').then(c => c.SalesOrderDetailPage),
    canActivate: [authGuard, moduleAccessGuard('oOrders')]
  },
  {
    path: 'sales-order-create',
    loadComponent: () => import('./features/sap-business-one/sales-order-create-page/sales-order-create-page').then(c => c.SalesOrderCreatePage),
    canActivate: [authGuard, moduleAccessGuard('oOrders')]
  },
  {
    path: 'goods-delivery',
    loadComponent: () => import('./features/sap-business-one/goods-delivery-page/goods-delivery-page').then(c => c.GoodsDeliveryPage),
    canActivate: [authGuard, moduleAccessGuard('oDeliveryNotes')]
  },
  {
    path: 'goods-delivery-create',
    loadComponent: () => import('./features/sap-business-one/goods-delivery-create-page/goods-delivery-create-page').then(c => c.GoodsDeliveryCreatePage),
    canActivate: [authGuard, moduleAccessGuard('oDeliveryNotes')]
  },
  {
    path: 'goods-delivery-detail/:docEntry',
    loadComponent: () => import('./features/sap-business-one/goods-delivery-detail-page/goods-delivery-detail-page').then(c => c.GoodsDeliveryDetailPage),
    canActivate: [authGuard, moduleAccessGuard('oDeliveryNotes')]
  },
  {
    path: 'customer-invoice',
    loadComponent: () => import('./features/sap-business-one/customer-invoice-page/customer-invoice-page').then(c => c.CustomerInvoicePage),
    canActivate: [authGuard, moduleAccessGuard('oInvoices')]
  },
  {
    path: 'customer-invoice-create',
    loadComponent: () => import('./features/sap-business-one/customer-invoice-create-page/customer-invoice-create-page').then(c => c.CustomerInvoiceCreatePage),
    canActivate: [authGuard, moduleAccessGuard('oInvoices')]
  },
  {
    path: 'customer-invoice-detail/:docNum',
    loadComponent: () => import('./features/sap-business-one/customer-invoice-detail-page/customer-invoice-detail-page').then(c => c.CustomerInvoiceDetailPage),
    canActivate: [authGuard, moduleAccessGuard('oInvoices')]
  },
  {
    path: 'sales-credit-notes',
    loadComponent: () => import('./features/sap-business-one/sales-credit-notes-page/sales-credit-notes-page').then(c => c.SalesCreditNotesPage),
    canActivate: [authGuard, moduleAccessGuard('oCreditNotes')]
  },
  {
    path: 'sales-credit-notes-create',
    loadComponent: () => import('./features/sap-business-one/sales-credit-notes-create-page/sales-credit-notes-create-page').then(c => c.SalesCreditNotesCreatePage),
    canActivate: [authGuard, moduleAccessGuard('oCreditNotes')]
  },
  {
    path: 'sales-credit-notes-detail/:docNum',
    loadComponent: () => import('./features/sap-business-one/sales-credit-notes-detail-page/sales-credit-notes-detail-page').then(c => c.SalesCreditNotesDetailPage),
    canActivate: [authGuard, moduleAccessGuard('oCreditNotes')]
  },
  
  // SAP Business One - Compras
  {
    path: 'purchase-order',
    loadComponent: () => import('./features/sap-business-one/purchase-order-page/purchase-order-page').then(c => c.PurchaseOrderPage),
    canActivate: [authGuard, moduleAccessGuard('oPurchaseOrders')]
  },
  {
    path: 'purchase-order-create',
    loadComponent: () => import('./features/sap-business-one/purchase-order-create-page/purchase-order-create-page').then(c => c.PurchaseOrderCreatePage),
    canActivate: [authGuard, moduleAccessGuard('oPurchaseOrders')]
  },
  {
    path: 'purchase-order-detail/:docNum',
    loadComponent: () => import('./features/sap-business-one/purchase-order-detail-page/purchase-order-detail-page').then(c => c.PurchaseOrderDetailPage),
    canActivate: [authGuard, moduleAccessGuard('oPurchaseOrders')]
  },
  {
    path: 'goods-receipt',
    loadComponent: () => import('./features/sap-business-one/goods-receipt-page/goods-receipt-page').then(c => c.GoodsReceiptPage),
    canActivate: [authGuard, moduleAccessGuard('oPurchaseDeliveryNotes')]
  },
  {
    path: 'goods-receipt-create',
    loadComponent: () => import('./features/sap-business-one/goods-receipt-create-page/goods-receipt-create-page').then(c => c.GoodsReceiptCreatePage),
    canActivate: [authGuard, moduleAccessGuard('oPurchaseDeliveryNotes')]
  },
  {
    path: 'goods-receipt-detail/:docEntry',
    loadComponent: () => import('./features/sap-business-one/goods-receipt-detail-page/goods-receipt-detail-page').then(c => c.GoodsReceiptDetailPage),
    canActivate: [authGuard, moduleAccessGuard('oPurchaseDeliveryNotes')]
  },
  {
    path: 'vendor-invoice',
    loadComponent: () => import('./features/sap-business-one/vendor-invoice-page/vendor-invoice-page').then(c => c.VendorInvoicePage),
    canActivate: [authGuard, moduleAccessGuard('oPurchaseInvoices')]
  },
  {
    path: 'vendor-invoice-create',
    loadComponent: () => import('./features/sap-business-one/vendor-invoice-create-page/vendor-invoice-create-page').then(c => c.VendorInvoiceCreatePage),
    canActivate: [authGuard, moduleAccessGuard('oPurchaseInvoices')]
  },
  {
    path: 'vendor-invoice-detail/:docEntry',
    loadComponent: () => import('./features/sap-business-one/vendor-invoice-detail-page/vendor-invoice-detail-page').then(c => c.VendorInvoiceDetailPage),
    canActivate: [authGuard, moduleAccessGuard('oPurchaseInvoices')]
  },
  
  // SAP Business One - Pagos
  {
    path: 'received-payments',
    loadComponent: () => import('./features/sap-business-one/received-payments-page/received-payments-page').then(c => c.ReceivedPaymentsPage),
    canActivate: [authGuard, moduleAccessGuard('oIncomingPayments')]
  },
  {
    path: 'received-payments-create',
    loadComponent: () => import('./features/sap-business-one/received-payments-create-page/received-payments-create-page').then(c => c.ReceivedPaymentsCreatePage),
    canActivate: [authGuard, moduleAccessGuard('oIncomingPayments')]
  },
  {
    path: 'received-payments-detail/:docEntry',
    loadComponent: () => import('./features/sap-business-one/received-payments-detail-page/received-payments-detail-page').then(c => c.ReceivedPaymentsDetailPage),
    canActivate: [authGuard, moduleAccessGuard('oIncomingPayments')]
  },
  {
    path: 'issued-payments',
    loadComponent: () => import('./features/sap-business-one/issued-payments-page/issued-payments-page').then(c => c.IssuedPaymentsPage),
    canActivate: [authGuard, moduleAccessGuard('oVendorPayments')]
  },
  {
    path: 'issued-payments-create',
    loadComponent: () => import('./features/sap-business-one/issued-payments-create-page/issued-payments-create-page').then(c => c.IssuedPaymentsCreatePage),
    canActivate: [authGuard, moduleAccessGuard('oVendorPayments')]
  },
  {
    path: 'issued-payments-detail/:docEntry',
    loadComponent: () => import('./features/sap-business-one/issued-payments-detail-page/issued-payments-detail-page').then(c => c.IssuedPaymentsDetailPage),
    canActivate: [authGuard, moduleAccessGuard('oVendorPayments')]
  },

  // SAP Business One - Socios de negocio
  {
    path: 'business-partners-clients',
    loadComponent: () => import('./features/sap-business-one/business-partners-clients-page/business-partners-clients-page').then(c => c.BusinessPartnersClientsPage),
    canActivate: [authGuard, moduleAccessGuard('oBusinessPartnersC')]
  },
  {
    path: 'business-partners-clients-create',
    loadComponent: () => import('./features/sap-business-one/business-partners-clients-create-page/business-partners-clients-create-page').then(c => c.BusinessPartnersClientsCreatePage),
    canActivate: [authGuard, moduleAccessGuard('oBusinessPartnersC')]
  },
  {
    path: 'business-partners-clients-detail/:cardCode',
    loadComponent: () => import('./features/sap-business-one/business-partners-clients-detail-page/business-partners-clients-detail-page').then(c => c.BusinessPartnersClientsDetailPage),
    canActivate: [authGuard]
  },
  {
    path: 'business-partners-clients-edit/:cardCode',
    loadComponent: () => import('./features/sap-business-one/business-partners-clients-edit-page/business-partners-clients-edit-page').then(c => c.BusinessPartnersClientsEditPage),
    canActivate: [authGuard]
  },
  {
    path: 'business-partners-clients-addresses-edit/:cardCode',
    loadComponent: () => import('./features/sap-business-one/business-partners-clients-addresses-edit-page/business-partners-clients-addresses-edit-page').then(c => c.BusinessPartnersClientsAddressesEditPage),
    canActivate: [authGuard]
  },
  {
    path: 'business-partners-suppliers',
    loadComponent: () => import('./features/sap-business-one/business-partners-suppliers-page/business-partners-suppliers-page').then(c => c.BusinessPartnersSuppliersPage),
    canActivate: [authGuard, moduleAccessGuard('oBusinessPartnersS')]
  },
  {
    path: 'business-partners-suppliers-create',
    loadComponent: () => import('./features/sap-business-one/business-partners-suppliers-create-page/business-partners-suppliers-create-page').then(c => c.BusinessPartnersSuppliersCreatePage),
    canActivate: [authGuard, moduleAccessGuard('oBusinessPartnersS')]
  },
  {
    path: 'business-partners-suppliers-detail/:cardCode',
    loadComponent: () => import('./features/sap-business-one/business-partners-suppliers-detail-page/business-partners-suppliers-detail-page').then(c => c.BusinessPartnersSuppliersDetailPage),
    canActivate: [authGuard]
  },
  {
    path: 'business-partners-suppliers-edit/:cardCode',
    loadComponent: () => import('./features/sap-business-one/business-partners-suppliers-edit-page/business-partners-suppliers-edit-page').then(c => c.BusinessPartnersSuppliersEditPage),
    canActivate: [authGuard]
  },
  {
    path: 'business-partners-suppliers-addresses-edit/:cardCode',
    loadComponent: () => import('./features/sap-business-one/business-partners-suppliers-addresses-edit-page/business-partners-suppliers-addresses-edit-page').then(c => c.BusinessPartnersSuppliersAddressesEditPage),
    canActivate: [authGuard]
  },
  
  // SAP Business One - Inventario
  {
    path: 'master-data',
    loadComponent: () => import('./features/sap-business-one/master-data-page/master-data-page').then(c => c.MasterDataPage),
    canActivate: [authGuard, moduleAccessGuard('oItems')]
  },
  {
    path: 'warehouse-entry',
    loadComponent: () => import('./features/sap-business-one/warehouse-entry-page/warehouse-entry-page').then(c => c.WarehouseEntryPage),
    canActivate: [authGuard, moduleAccessGuard('oInventoryGenEntry')]
  },
    {
    path: 'warehouse-entry-create',
    loadComponent: () => import('./features/sap-business-one/warehouse-entry-create-page/warehouse-entry-create-page').then(c => c.WarehouseEntryCreatePage),
    canActivate: [authGuard, moduleAccessGuard('oInventoryGenEntry')]
  },
  {
    path: 'warehouse-entry-detail/:docEntry',
    loadComponent: () => import('./features/sap-business-one/warehouse-entry-detail-page/warehouse-entry-detail-page').then(c => c.WarehouseEntryDetailPage),
    canActivate: [authGuard, moduleAccessGuard('oInventoryGenEntry')]
  },
  {
    path: 'warehouse-outbound',
    loadComponent: () => import('./features/sap-business-one/warehouse-outbound-page/warehouse-outbound-page').then(c => c.WarehouseOutboundPage),
    canActivate: [authGuard, moduleAccessGuard('oInventoryGenExit')]
  },
  {
    path: 'warehouse-outbound-create',
    loadComponent: () => import('./features/sap-business-one/warehouse-outbound-create-page/warehouse-outbound-create-page').then(c => c.WarehouseOutboundCreatePage),
    canActivate: [authGuard, moduleAccessGuard('oInventoryGenExit')]
  },
  {
    path: 'warehouse-outbound-detail/:docEntry',
    loadComponent: () => import('./features/sap-business-one/warehouse-outbound-detail-page/warehouse-outbound-detail-page').then(c => c.WarehouseOutboundDetailPage),
    canActivate: [authGuard, moduleAccessGuard('oInventoryGenExit')]
  },
  
  // SAP Business One - Traspasos
  {
    path: 'transfer-request',
    loadComponent: () => import('./features/sap-business-one/transfer-request-page/transfer-request-page').then(c => c.TransferRequestPage),
    canActivate: [authGuard, moduleAccessGuard('oInventoryTransferRequest')]
  },
  {
    path: 'transfer-request-create',
    loadComponent: () => import('./features/sap-business-one/transfer-request-create-page/transfer-request-create-page').then(c => c.TransferRequestCreatePage),
    canActivate: [authGuard, moduleAccessGuard('oInventoryTransferRequest')]
  },
  {
    path: 'transfer-request-detail/:docNum',
    loadComponent: () => import('./features/sap-business-one/transfer-request-detail-page/transfer-request-detail-page').then(c => c.TransferRequestDetailPage),
    canActivate: [authGuard, moduleAccessGuard('oInventoryTransferRequest')]
  },
  {
    path: 'transfer',
    loadComponent: () => import('./features/sap-business-one/transfer-page/transfer-page').then(c => c.TransferPage),
    canActivate: [authGuard, moduleAccessGuard('oStockTransfer')]
  },
  {
    path: 'transfer-create',
    loadComponent: () => import('./features/sap-business-one/transfer-create-page/transfer-create-page').then(c => c.TransferCreatePage),
    canActivate: [authGuard, moduleAccessGuard('oStockTransfer')]
  },
  {
    path: 'transfer-detail/:docNum',
    loadComponent: () => import('./features/sap-business-one/transfer-detail-page/transfer-detail-page').then(c => c.TransferDetailPage),
    canActivate: [authGuard, moduleAccessGuard('oStockTransfer')]
  },
  
  // RH
  {
    path: 'rh',
    loadComponent: () => import('./features/rh/rh-page/rh-page').then(c => c.RhPage),
    canActivate: [authGuard]
  },
  {
    path: 'birthday-kit',
    loadComponent: () => import('./features/rh/birthday-kit-page/birthday-kit-page').then(c => c.BirthdayKitPage),
    canActivate: [authGuard, moduleAccessGuard('oKitBirthday')]
  },
  {
    path: 'birthday-kit-create',
    loadComponent: () => import('./features/rh/birthday-kit-create-page/birthday-kit-create-page').then(c => c.BirthdayKitCreatePage),
    canActivate: [authGuard, moduleAccessGuard('oKitBirthday')]
  },
  {
    path: 'birthday-kit-detail/:docNum',
    loadComponent: () => import('./features/rh/birthday-kit-detail-page/birthday-kit-detail-page').then(c => c.BirthdayKitDetailPage),
    canActivate: [authGuard, moduleAccessGuard('oKitBirthday')]
  },
  {
    path: 'welcome-kit',
    loadComponent: () => import('./features/rh/welcome-kit-page/welcome-kit-page').then(c => c.WelcomeKitPage),
    canActivate: [authGuard, moduleAccessGuard('oKitWelcome')]
  },
  {
    path: 'welcome-kit-create',
    loadComponent: () => import('./features/rh/welcome-kit-create-page/welcome-kit-create-page').then(c => c.WelcomeKitCreatePage),
    canActivate: [authGuard, moduleAccessGuard('oKitWelcome')]
  },
  {
    path: 'welcome-kit-detail/:docNum',
    loadComponent: () => import('./features/rh/welcome-kit-detail-page/welcome-kit-detail-page').then(c => c.WelcomeKitDetailPage),
    canActivate: [authGuard, moduleAccessGuard('oKitWelcome')]
  },
  {
    path: 'internal-consumption',
    loadComponent: () => import('./features/rh/internal-consumption-page/internal-consumption-page').then(c => c.InternalConsumptionPage),
    canActivate: [authGuard, moduleAccessGuard('oInternalConsumption')]
  },
  {
    path: 'internal-consumption-create',
    loadComponent: () => import('./features/rh/internal-consumption-create-page/internal-consumption-create-page').then(c => c.InternalConsumptionCreatePage),
    canActivate: [authGuard, moduleAccessGuard('oInternalConsumption')]
  },
  {
    path: 'internal-consumption-detail/:docNum',
    loadComponent: () => import('./features/rh/internal-consumption-detail-page/internal-consumption-detail-page').then(c => c.InternalConsumptionDetailPage),
    canActivate: [authGuard, moduleAccessGuard('oInternalConsumption')]
  },
  {
    path: 'employee-sale',
    loadComponent: () => import('./features/rh/employee-sale-page/employee-sale-page').then(c => c.EmployeeSalePage),
    canActivate: [authGuard, moduleAccessGuard('oEmployeeSale')]
  },
  {
    path: 'employee-sale-create',
    loadComponent: () => import('./features/rh/employee-sale-create-page/employee-sale-create-page').then(c => c.EmployeeSaleCreatePage),
    canActivate: [authGuard, moduleAccessGuard('oEmployeeSale')]
  },
  {
    path: 'employee-sale-detail/:docNum',
    loadComponent: () => import('./features/rh/employee-sale-detail-page/employee-sale-detail-page').then(c => c.EmployeeSaleDetailPage),
    canActivate: [authGuard, moduleAccessGuard('oEmployeeSale')]
  },
  
  // Almacén
  {
    path: 'warehouse',
    loadComponent: () => import('./features/warehouse/warehouse-page/warehouse-page').then(c => c.WarehousePage),
    canActivate: [authGuard]
  },
  {
    path: 'unit-conversion',
    loadComponent: () => import('./features/warehouse/unit-conversion-page/unit-conversion-page').then(c => c.UnitConversionPage),
    canActivate: [authGuard, moduleAccessGuard('oUnitConversion')]
  },
  {
  path: 'unit-conversion-create',
    loadComponent: () => import('./features/warehouse/unit-conversion-create-page/unit-conversion-create-page').then(m => m.UnitConversionCreatePage)
  },
  {
    path: 'unit-conversion-detail/:docNum',
    loadComponent: () => import('./features/warehouse/unit-conversion-detail-page/unit-conversion-detail-page').then(m => m.UnitConversionDetailPage)
  },
  {
    path: 'product-reprocess',
    loadComponent: () => import('./features/warehouse/product-reprocess-page/product-reprocess-page').then(c => c.ProductReprocessPage),
    canActivate: [authGuard, moduleAccessGuard('oProductReprocessing')]
  },
  {
    path: 'product-reprocess-create',
    loadComponent: () => import('./features/warehouse/product-reprocess-create-page/product-reprocess-create-page').then(c => c.ProductReprocessCreatePage),
    canActivate: [authGuard, moduleAccessGuard('oProductReprocessing')]
  },
  {
    path: 'product-reprocess-detail/:docNum',
    loadComponent: () => import('./features/warehouse/product-reprocess-detail-page/product-reprocess-detail-page').then(m => m.ProductReprocessDetailPage),
    canActivate: [authGuard, moduleAccessGuard('oProductReprocessing')]
  },
  {
    path: 'losses',
    loadComponent: () => import('./features/warehouse/losses-page/losses-page').then(c => c.LossesPage),
    canActivate: [authGuard, moduleAccessGuard('oWastage')]
  },
  {
    path: 'losses-create',
    loadComponent: () => import('./features/warehouse/losses-create-page/losses-create-page').then(c => c.LossesCreatePage),
    canActivate: [authGuard, moduleAccessGuard('oWastage')]
  },
  {
    path: 'losses-detail/:docNum',
    loadComponent: () => import('./features/warehouse/losses-detail-page/losses-detail-page').then(m => m.LossesDetailPage),
    canActivate: [authGuard, moduleAccessGuard('oWastage')]
  },
  {
    path: 'pending-sync-documents',
    loadComponent: () => import('./features/warehouse/pending-sync-documents-page/pending-sync-documents-page').then(c => c.PendingSyncDocumentsPage),
    canActivate: [authGuard, moduleAccessGuard('oPendingSyncDocuments')]
  },
  {
    path: 'pending-sync-documents/detail',
    loadComponent: () => import('./features/warehouse/pending-sync-documents-detail-page/pending-sync-documents-detail-page').then(c => c.PendingSyncDocumentsDetailPage),
    canActivate: [authGuard, moduleAccessGuard('oPendingSyncDocuments')]
  },
  
  // Sistemas
  {
    path: 'systems',
    loadComponent: () => import('./features/systems/systems-page/systems-page').then(c => c.SystemsPage),
    canActivate: [authGuard]
  },
  {
    path: 'monitoring',
    loadComponent: () => import('./features/systems/monitoring-page/monitoring-page').then(c => c.MonitoringPage),
    canActivate: [authGuard, moduleAccessGuard('oMonitoring')]
  },
  {
    path: 'monitoring/sync-service',
    loadComponent: () => import('./features/systems/sync-service-page/sync-service-page').then(c => c.SyncServicePage),
    canActivate: [authGuard, moduleAccessGuard('oMonitoring')]
  },
  {
    path: 'sync-service/document-detail',
    loadComponent: () => import('./features/systems/sync-service-document-detail-page/sync-service-document-detail-page').then(c => c.SyncServiceDocumentDetailPage),
    canActivate: [authGuard, moduleAccessGuard('oMonitoring')]
  },
  {
    path: 'monitoring/documents',
    loadComponent: () => import('./features/systems/documents-page/documents-page').then(c => c.DocumentsPage),
    canActivate: [authGuard, moduleAccessGuard('oMonitoring')]
  },
  {
    path: 'documents-detail',
    loadComponent: () => import('./features/systems/documents-detail-page/documents-detail-page').then(c => c.DocumentsDetailPage),
    canActivate: [authGuard, moduleAccessGuard('oMonitoring')]
  },
  {
    path: 'users',
    loadComponent: () => import('./features/systems/users-page/users-page').then(c => c.UsersPage),
    canActivate: [authGuard, moduleAccessGuard('oUsers')]
  },
  {
    path: 'users-create',
    loadComponent: () => import('./features/systems/users-create-page/users-create-page').then(c => c.UsersCreatePage),
    canActivate: [authGuard, moduleAccessGuard('oUsers')]
  },
  {
    path: 'modules',
    loadComponent: () => import('./features/systems/modules-page/modules-page').then(c => c.ModulesPage),
    canActivate: [authGuard, moduleAccessGuard('oModules')]
  },
  {
    path: 'modules-create',
    loadComponent: () => import('./features/systems/modules-create-page/modules-create-page').then(c => c.ModulesCreatePage),
    canActivate: [authGuard, moduleAccessGuard('oModules')]
  },
  {
    path: 'versions',
    loadComponent: () => import('./features/systems/versions-page/versions-page').then(c => c.VersionsPage),
    canActivate: [authGuard, moduleAccessGuard('oVersions')]
  },
  {
    path: 'commands',
    loadComponent: () => import('./features/systems/commands-page/commands-page').then(c => c.CommandsPage),
    canActivate: [authGuard, moduleAccessGuard('oCommands')]
  },
  {
    path: 'commands/cancel-document/create',
    loadComponent: () => import('./features/systems/cancel-document-create-page/cancel-document-create-page').then(c => c.CancelDocumentCreatePage),
    canActivate: [authGuard, moduleAccessGuard('oCommands')]
  },
  {
    path: 'commands/manual/create',
    loadComponent: () => import('./features/systems/manual-command-create-page/manual-command-create-page').then(c => c.ManualCommandCreatePage),
    canActivate: [authGuard, moduleAccessGuard('oCommands')]
  },
  {
    path: 'equipment-assignment',
    loadComponent: () => import('./features/systems/equipment-assignment-page/equipment-assignment-page').then(c => c.EquipmentAssignmentPage),
    canActivate: [authGuard, moduleAccessGuard('oMobileAssignment')]
  },
  {
    path: 'equipment-assignment-create',
    loadComponent: () => import('./features/systems/equipment-assignment-create-page/equipment-assignment-create-page').then(c => c.EquipmentAssignmentCreatePage),
    canActivate: [authGuard, moduleAccessGuard('oMobileAssignment')]
  },
  {
    path: 'equipment-assignment-edit/:uLMUser',
    loadComponent: () => import('./features/systems/equipment-assignment-edit-page/equipment-assignment-edit-page').then(c => c.EquipmentAssignmentEditPage),
    canActivate: [authGuard, moduleAccessGuard('oMobileAssignment')]
  },
  {
    path: 'equipment-assignment-detail/:uLMUser',
    loadComponent: () => import('./features/systems/equipment-assignment-detail-page/equipment-assignment-detail-page').then(c => c.EquipmentAssignmentDetailPage),
    canActivate: [authGuard, moduleAccessGuard('oMobileAssignment')]
  },

  // Administración
  
  {
    path: 'administration',
    loadComponent: () => import('./features/administration/administration-page/administration-page').then(c => c.AdministrationPage),
    canActivate: [authGuard]
  },
  {
    path: 'warehouse-percentages',
    loadComponent: () => import('./features/administration/warehouse-percentages-page/warehouse-percentages-page').then(c => c.WarehousePercentagesPage),
    canActivate: [authGuard, moduleAccessGuard('oWarehousePercentages')]
  },
  {
    path: 'cancel-documents-admon',
    loadComponent: () => import('./features/administration/cancel-documents-admon-page/cancel-documents-admon-page').then(c => c.CancelDocumentsAdmonPage),
    canActivate: [authGuard, moduleAccessGuard('oCancelDocumentsAdmon')]
  },

  // Cobranza
  
  {
    path: 'collections',
    loadComponent: () => import('./features/collections/collections-page/collections-page').then(c => c.CollectionsPage),
    canActivate: [authGuard] 
  },
  {
    path: 'collections/mass-payments',
    loadComponent: () => import('./features/collections/mass-payments-page/mass-payments-page').then(c => c.MassPaymentsPage),
    canActivate: [authGuard, moduleAccessGuard('oIncomingPaymentsMass')]
  },
  {
    path: 'collections/credit-notes-mass',
    loadComponent: () => import('./features/collections/credit-notes-mass-page/credit-notes-mass-page').then(c => c.CreditNotesMassPage),
    canActivate: [authGuard, moduleAccessGuard('oCreditNotesMass')]
  },
  {
    path: 'collections/payment-promise-date',
    loadComponent: () => import('./features/collections/payment-promise-date-page/payment-promise-date-page').then(c => c.PaymentPromiseDatePage),
    canActivate: [authGuard, moduleAccessGuard('oPromisedPaymentDate')]  
  },
  {
    path: 'collections/electronic-protocol-status',
    loadComponent: () => import('./features/collections/electronic-protocol-status-page/electronic-protocol-status-page').then(c => c.ElectronicProtocolStatusPage),
    canActivate: [authGuard, moduleAccessGuard('oElectronicProtocolStatusINV')]
  },
  {
    path: 'collections/ticket-delivery',
    loadComponent: () => import('./features/collections/ticket-delivery-page/ticket-delivery-page').then(c => c.TicketDeliveryPage),
    canActivate: [authGuard, moduleAccessGuard('oTicketDelivery')]
  },
  {
    path: 'collections/ticket-reception',
    loadComponent: () => import('./features/collections/ticket-reception-page/ticket-reception-page').then(c => c.TicketReceptionPage),
    canActivate: [authGuard]  // Sin moduleAccessGuard por ahora (no tiene ID)
  },
  {
     path: 'collections/multi-ticket-collection',
     loadComponent: () => import('./features/collections/multi-ticket-collection-page/multi-ticket-collection-page').then(c => c.MultiTicketCollectionPage),
     canActivate: [authGuard, moduleAccessGuard('oMultiTicketCollection')]
   },

  // Comercial

  {
    path: 'commercial',
    loadComponent: () => import('./features/commercial/commercial-page/commercial-page').then(c => c.CommercialPage),
    canActivate: [authGuard]
  },
  {
    path: 'tastings',
    loadComponent: () => import('./features/commercial/tastings-page/tastings-page').then(c => c.TastingsPage),
    canActivate: [authGuard, moduleAccessGuard('oTastings')]
  },
  {
    path: 'tastings-create',
    loadComponent: () => import('./features/commercial/tastings-create-page/tastings-create-page').then(c => c.TastingsCreatePage),
    canActivate: [authGuard, moduleAccessGuard('oTastings')]
  },
  {
    path: 'tastings-detail/:docNum',
    loadComponent: () => import('./features/commercial/tastings-detail-page/tastings-detail-page').then(c => c.TastingsDetailPage),
    canActivate: [authGuard, moduleAccessGuard('oTastings')]
  },
  {
    path: 'benefits',
    loadComponent: () => import('./features/commercial/benefits-page/benefits-page').then(c => c.BenefitsPage),
    canActivate: [authGuard, moduleAccessGuard('oBenefits')]
  },
  {
    path: 'benefits-create',
    loadComponent: () => import('./features/commercial/benefits-create-page/benefits-create-page').then(c => c.BenefitsCreatePage),
    canActivate: [authGuard, moduleAccessGuard('oBenefits')]
  },
  {
    path: 'benefits-detail/:docNum',
    loadComponent: () => import('./features/commercial/benefits-detail-page/benefits-detail-page').then(c => c.BenefitsDetailPage),
    canActivate: [authGuard, moduleAccessGuard('oBenefits')]
  },
  {
    path: 'price-importer',
    loadComponent: () => import('./features/commercial/price-importer-page/price-importer-page').then(c => c.PriceImporterPage),
    canActivate: [authGuard, moduleAccessGuard('oPriceImporter')]
  },
  {
    path: 'price-importer-create',
    loadComponent: () => import('./features/commercial/price-importer-create-page/price-importer-create-page').then(c => c.PriceImporterCreatePage),
    canActivate: [authGuard, moduleAccessGuard('oPriceImporter')]
  },
  {
    path: 'price-lists',
    loadComponent: () => import('./features/commercial/price-lists-page/price-lists-page').then(c => c.PriceListsPage),
    canActivate: [authGuard, moduleAccessGuard('oPriceLists')]
  },
  {
    path: 'special-prices',
    loadComponent: () => import('./features/commercial/special-prices-page/special-prices-page').then(c => c.SpecialPricesPage),
    canActivate: [authGuard, moduleAccessGuard('oSpecialPrices')]
  },
  {
    path: 'pre-sale',
    loadComponent: () => import('./features/commercial/pre-sale-page/pre-sale-page').then(c => c.PreSalePage),
    canActivate: [authGuard, moduleAccessGuard('oPreSalesHerdez')]
  },
  {
    path: 'pre-sale/herdez',
    loadComponent: () => import('./features/commercial/pre-sale-herdez-page/pre-sale-herdez-page').then(c => c.PreSaleHerdezPage),
    canActivate: [authGuard, moduleAccessGuard('oPreSalesHerdez')]  
  },
  {
    path: 'visits',
    loadComponent: () => import('./features/commercial/visits-page/visits-page').then(c => c.VisitsPage),
    canActivate: [authGuard, moduleAccessGuard('oVisits')]
  },
  {
    path: 'promotions',
    loadComponent: () => import('./features/commercial/promotions-page/promotions-page').then(c => c.PromotionsPage),
    canActivate: [authGuard, moduleAccessGuard('oSetUpPromotions')]
  },
  {
    path: 'promotions/one-to-one',
    loadComponent: () => import('./features/commercial/promotions-one-to-one-page/promotions-one-to-one-page').then(c => c.PromotionsOneToOnePage),
    canActivate: [authGuard, moduleAccessGuard('oSetUpPromotions')]
  },
  {
    path: 'promotions/one-to-one/create',
    loadComponent: () => import('./features/commercial/promotions-one-to-one-create-page/promotions-one-to-one-create-page').then(c => c.PromotionsOneToOneCreatePage),
    canActivate: [authGuard, moduleAccessGuard('oSetUpPromotions')]
  },
  {
    path: 'promotions/one-to-one/assign',
    loadComponent: () => import('./features/commercial/promotions-one-to-one-assign-page/promotions-one-to-one-assign-page').then(c => c.PromotionsOneToOneAssignPage),
    canActivate: [authGuard, moduleAccessGuard('oSetUpPromotions')]
  },
  {
    path: 'promotions/one-to-one/edit',
    loadComponent: () => import('./features/commercial/promotions-one-to-one-edit-page/promotions-one-to-one-edit-page').then(c => c.PromotionsOneToOneEditPage),
    canActivate: [authGuard, moduleAccessGuard('oSetUpPromotions')]
  },
  {
    path: 'promotions/volume',
    loadComponent: () => import('./features/commercial/promotions-volume-page/promotions-volume-page').then(c => c.PromotionsVolumePage),
    canActivate: [authGuard, moduleAccessGuard('oSetUpPromotions')]
  },
  {
    path: 'promotions/volume/create',
    loadComponent: () => import('./features/commercial/promotions-volume-create-page/promotions-volume-create-page').then(c => c.PromotionsVolumeCreatePage),
    canActivate: [authGuard, moduleAccessGuard('oSetUpPromotions')]
  },
  {
    path: 'promotions/volume/assign',
    loadComponent: () => import('./features/commercial/promotions-volume-assign-page/promotions-volume-assign-page').then(c => c.PromotionsVolumeAssignPage),
    canActivate: [authGuard, moduleAccessGuard('oSetUpPromotions')]
  },
  {
    path: 'promotions/volume/edit',
    loadComponent: () => import('./features/commercial/promotions-volume-edit-page/promotions-volume-edit-page').then(c => c.PromotionsVolumeEditPage),
    canActivate: [authGuard, moduleAccessGuard('oSetUpPromotions')]
  },
  {
    path: 'promotions/enable',
    loadComponent: () => import('./features/commercial/enable-promotions-page/enable-promotions-page').then(c => c.EnablePromotionsPage),
    canActivate: [authGuard, moduleAccessGuard('oEnablePromotions')]
  },
  {
    path: 'surveys',
    loadComponent: () => import('./features/commercial/surveys-page/surveys-page').then(c => c.SurveysPage),
    canActivate: [authGuard, moduleAccessGuard('oSetUpSurveys')]
  },
  {
    path: 'surveys/google',
    loadComponent: () => import('./features/commercial/surveys-google-page/surveys-google-page').then(c => c.SurveysGooglePage),
    canActivate: [authGuard, moduleAccessGuard('oSetUpSurveys')]
  },
  {
    path: 'surveys/google/create',
    loadComponent: () => import('./features/commercial/surveys-google-create-page/surveys-google-create-page').then(c => c.SurveysGoogleCreatePage),
    canActivate: [authGuard, moduleAccessGuard('oSetUpSurveys')]
  },
  {
    path: 'installer-token',
    loadComponent: () => import('./features/commercial/installer-token-page/installer-token-page').then(c => c.InstallerTokenPage),
    canActivate: [authGuard, moduleAccessGuard('oInstallerToken')]
  },
  {
    path: 'installer-apk',
    loadComponent: () => import('./features/commercial/installer-apk-page/installer-apk-page').then(c => c.InstallerApkPage),
    canActivate: [authGuard, moduleAccessGuard('oInstallerApk')]
  },
  {
    path: 'geofences',
    loadComponent: () => import('./features/commercial/geofences-page/geofences-page').then(c => c.GeofencesPage),
    canActivate: [authGuard, moduleAccessGuard('oGeofences')]
  },
  {
    path: 'geofences/create',
    loadComponent: () => import('./features/commercial/geofences-create-page/geofences-create-page').then(c => c.GeofencesCreatePage),
    canActivate: [authGuard, moduleAccessGuard('oGeofences')]
  },
  {
    path: 'promotoras',
    loadComponent: () => import('./features/commercial/promotoras-page/promotoras-page').then(c => c.PromotorasPage),
    canActivate: [authGuard, moduleAccessGuard('oPromoters')]
  },
  // {
  //   path: 'promotoras/schedule-visits',
  //   loadComponent: () => import('./features/commercial/schedule-visits-page/schedule-visits-page').then(c => c.ScheduleVisitsPage),
  //   canActivate: [authGuard]
  // },
  {
    path: 'promotoras/assigned-visits',
    loadComponent: () => import('./features/commercial/assigned-visits-page/assigned-visits-page').then(c => c.AssignedVisitsPage),
    canActivate: [authGuard, moduleAccessGuard('oScheduleItinerary')]
  },
  {
    path: 'promotoras/delete-promoters',
    loadComponent: () => import('./features/commercial/delete-promoters-page/delete-promoters-page').then(c => c.DeletePromotersPage),
    canActivate: [authGuard, moduleAccessGuard('oDeleteItinerary')]
  },
  {
    path: 'promotoras/itinerary-map',
    loadComponent: () => import('./features/commercial/itinerary-map-page/itinerary-map-page').then(c => c.ItineraryMapPage),
    canActivate: [authGuard, moduleAccessGuard('oItineraryMap')]
  },
  {
    path: 'promotoras/itinerary-reports',
    loadComponent: () => import('./features/commercial/itinerary-reports-page/itinerary-reports-page').then(c => c.ItineraryReportsPage),
    canActivate: [authGuard]
  },
  {
    path: 'product-classification',
    loadComponent: () => import('./features/commercial/product-classification-page/product-classification-page').then(c => c.ProductClassificationPage),
    canActivate: [authGuard, moduleAccessGuard('oProductClassification')]
  },
  {
    path: 'suggested-orders',
    loadComponent: () => import('./features/commercial/suggested-orders-page/suggested-orders-page').then(c => c.SuggestedOrdersPage),
    canActivate: [authGuard, moduleAccessGuard('oSuggestedOrder')]
  },
  {
    path: 'suggested-orders/config',
    loadComponent: () => import('./features/commercial/suggested-orders-config-page/suggested-orders-config-page').then(c => c.SuggestedOrdersConfigPage),
    canActivate: [authGuard, moduleAccessGuard('oSuggestedOrder')]
  },
  {
    path: 'risk-percentage',
    loadComponent: () => import('./features/commercial/risk-percentage-page/risk-percentage-page').then(c => c.RiskPercentagePage),
    canActivate: [authGuard, moduleAccessGuard('oRiskPercentage')]
  },
  {
    path: 'suggested-orders/order-mode',
    loadComponent: () => import('./features/commercial/order-mode-page/order-mode-page').then(c => c.OrderModePage),
    canActivate: [authGuard]
  },

  // Logística

  {
    path: 'logistics',
    loadComponent: () => import('./features/logistics/logistics-page/logistics-page').then(c => c.LogisticsPage),
    canActivate: [authGuard]
  },
  {
    path: 'logistics/fleet',
    loadComponent: () => import('./features/logistics/fleet-page/fleet-page').then(c => c.FleetPage),
    canActivate: [authGuard, moduleAccessGuard('oVehicles')]
  },
  {
    path: 'logistics/fleet/create',
    loadComponent: () => import('./features/logistics/vehicle-create-page/vehicle-create-page').then(c => c.VehicleCreatePage),
    canActivate: [authGuard, moduleAccessGuard('oVehicles')]
  },
  {
    path: 'logistics/fleet/detail/:unitNumber',
    loadComponent: () => import('./features/logistics/vehicle-detail-page/vehicle-detail-page').then(c => c.VehicleDetailPage),
    canActivate: [authGuard, moduleAccessGuard('oVehicles')]
  },
  {
    path: 'logistics/fleet/edit/:unitNumber',
    loadComponent: () => import('./features/logistics/vehicle-edit-page/vehicle-edit-page').then(c => c.VehicleEditPage),
    canActivate: [authGuard, moduleAccessGuard('oVehicles')]
  },
  {
    path: 'logistics/inspection-weekly',
    loadComponent: () => import('./features/logistics/inspection-weekly-page/inspection-weekly-page').then(c => c.InspectionWeeklyPage),
    canActivate: [authGuard, moduleAccessGuard('oInspectionWeekly')]
  },
  {
    path: 'logistics/inspection-weekly/detail/:folio',
    loadComponent: () => import('./features/logistics/inspection-weekly-detail-page/inspection-weekly-detail-page').then(c => c.InspectionWeeklyDetailPage),
    canActivate: [authGuard, moduleAccessGuard('oInspectionWeekly')]
  },
  {
    path: 'logistics/inspection-daily',
    loadComponent: () => import('./features/logistics/inspection-daily-page/inspection-daily-page').then(c => c.InspectionDailyPage),
    canActivate: [authGuard, moduleAccessGuard('oInspectionDaily')]
  },
  {
    path: 'logistics/inspection-daily/detail/:folio',
    loadComponent: () => import('./features/logistics/inspection-daily-detail-page/inspection-daily-detail-page').then(c => c.InspectionDailyDetailPage),
    canActivate: [authGuard, moduleAccessGuard('oInspectionDaily')]
  },

  // Módulo PEDIDOS

  {
    path: 'orders',
    loadComponent: () => import('./features/orders/orders-page/orders-page').then(c => c.OrdersPage),
    canActivate: [authGuard]
  },
  {
    path: 'authorize-order',
    loadComponent: () => import('./features/orders/authorize-order-page/authorize-order-page').then(c => c.AuthorizeOrderPage),
    canActivate: [authGuard, moduleAccessGuard('oAuthorizeOrder')]
  },
  {
    path: 'authorize-order-detail/:docNum',
    loadComponent: () => import('./features/orders/authorize-order-detail-page/authorize-order-detail-page').then(c => c.AuthorizeOrderDetailPage),
    canActivate: [authGuard, moduleAccessGuard('oAuthorizeOrder')]
  },

  // Módulo operaciones

  {
    path: 'operations',
    loadComponent: () => import('./features/operations/operations-page/operations-page').then(c => c.OperationsPage),
    canActivate: [authGuard]
  },
  {
    path: 'block-users',
    loadComponent: () => import('./features/operations/block-users-page/block-users-page').then(c => c.BlockUsersPage),
    canActivate: [authGuard, moduleAccessGuard('oBlockUsers')]
  },

    
  { path: '**', redirectTo: '/login' }
];